import React from 'react';

import { Row, Col, Button } from 'antd';
import {
  ClearOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  UndoOutlined,
  StopOutlined,
} from '@ant-design/icons';
import { useIsMutating } from '@tanstack/react-query';

const DownloadFolderModalFooter = (props) => {
  const {
    settingStep,
    deliveryMethod,

    onClear,
    onReset,
    onCancel,
    onSchedule,
    onExecuteNow,
    onScheduleSetting,
    onBackToDownloadSetting,
  } = props;

  const isDownloadSettingStep = settingStep === 0;

  const isExecuteNowLoading = useIsMutating({
    mutationKey: ['download-folder'],
  });
  const isScheduleLoading = useIsMutating({
    mutationKey: ['schedule-download-config'],
  });
  const isUpdateScheduleLoading = useIsMutating({
    mutationKey: ['update-schedule-download-folder'],
  });

  return (
    <Row wrap={false}>
      <Col flex={0}>
        <Button icon={<ClearOutlined />} onClick={onClear}>
          Clear
        </Button>
        <Button icon={<UndoOutlined />} onClick={onReset}>
          Reset
        </Button>
      </Col>

      <Col flex={1}></Col>

      <Col flex={0}>
        {isDownloadSettingStep ? (
          <Button
            type='primary'
            icon={<ArrowRightOutlined />}
            disabled={deliveryMethod === 'direct'}
            onClick={onScheduleSetting}
          >
            Schedule Setting
          </Button>
        ) : (
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={onBackToDownloadSetting}
          >
            Back to Download Setting
          </Button>
        )}

        <Button onClick={onCancel}>Cancel</Button>

        {isDownloadSettingStep ? (
          <Button
            type='primary'
            onClick={onExecuteNow}
            loading={isExecuteNowLoading}
          >
            Execute Now
          </Button>
        ) : (
          <Button
            type='primary'
            onClick={onSchedule}
            loading={isScheduleLoading || isUpdateScheduleLoading}
          >
            Schedule
          </Button>
        )}
      </Col>
    </Row>
  );
};

export default DownloadFolderModalFooter;
